var map = {
	"./CAD.png": 193,
	"./CRC.png": 5611,
	"./GBP.png": 2264,
	"./USD.png": 9081,
	"./auctionItemTestImages/cookies3.png": 5408,
	"./auctionItemTestImages/cookies4.png": 6315,
	"./profile-picture.png": 9749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;